export default {
  path: '/group-recode',
  meta: {
    title: '参团记录',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/group-recode`),
}



// WEBPACK FOOTER //
// ./src/views/GroupRecord/router.js